import { Play, Star, Ship } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { photoUrl } from "./ApplicantCard";

const getEmbed = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0`;
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}?dnt=1`;
  return null;
};

export const AuditionModal = ({ applicant, onClose, onVote, voted, onInquire }) => {
  const embed = applicant ? getEmbed(applicant.video_url) : null;
  const isYacht = applicant?.kind === "yacht";
  return (
    <Dialog open={!!applicant} onOpenChange={(open) => !open && onClose()}>
      <DialogContent aria-describedby={undefined} className="bg-[#0B111B] border border-[#D4AF37]/30 text-[#F7F8F9] max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="audition-modal">
        {applicant && (
          <>
            <DialogHeader>
              <DialogTitle className="font-display tracking-[0.1em] text-[#F5F3EF]" data-testid="audition-modal-name">
                {applicant.name} — {applicant.role}
              </DialogTitle>
            </DialogHeader>
            {isYacht ? (
              <div className="aspect-video mt-2 border border-[#D4AF37]/25 bg-[#070A0F] overflow-hidden">
                <img src={photoUrl(applicant)} alt={`${applicant.name} transom`} className="w-full h-full object-cover" data-testid="audition-yacht-photo" />
              </div>
            ) : embed ? (
              <div className="aspect-video mt-2">
                <iframe src={embed} title={`${applicant.name} audition`} className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
              </div>
            ) : (
              <div className="aspect-video mt-2 border border-[#D4AF37]/25 bg-[#070A0F] flex flex-col items-center justify-center gap-3">
                <span className="h-14 w-14 rounded-full border-2 border-[#D4AF37] text-[#D4AF37] flex items-center justify-center">
                  <Play size={20} fill="currentColor" className="ml-0.5" />
                </span>
                <p className="font-coords text-[10px] tracking-[0.3em] text-[#94A3B8]">AUDITION TAPE IN THE EDIT BAY</p>
                <p className="text-xs text-[#94A3B8]/70">Premieres with the pilot episode.</p>
              </div>
            )}
            <p className="text-sm text-[#94A3B8] leading-relaxed mt-4">{applicant.bio}</p>
            {applicant.highlights?.length > 0 && (
              <div className="flex flex-wrap gap-1.5 mt-3" data-testid="audition-highlights">
                {applicant.highlights.map((h) => (
                  <span key={h} className="text-[9px] tracking-[0.1em] uppercase text-[#E8C15A]/80 border border-[#D4AF37]/25 px-2 py-0.5">{h}</span>
                ))}
              </div>
            )}
            <div className="flex items-center justify-between mt-6 gap-4 flex-wrap">
              <span className="font-coords text-[10px] tracking-[0.25em] text-[#E8C15A] uppercase">
                {[applicant.hometown, applicant.license_level, applicant.experience].filter(Boolean).join(" · ")}
              </span>
              <div className="flex items-center gap-2">
                {isYacht && onInquire && (
                  <button onClick={() => onInquire(applicant)}
                    className="flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase border border-[#D4AF37]/50 text-[#F5F3EF] px-4 py-2.5 hover:bg-[#D4AF37] hover:text-[#070A0F] transition-colors duration-300"
                    data-testid="audition-charter-btn">
                    <Ship size={13} /> Charter
                  </button>
                )}
                <button
                  onClick={() => onVote(applicant)}
                  disabled={voted}
                  className="flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase bg-[#D4AF37] text-[#070A0F] px-5 py-2.5 hover:bg-[#F3E08A] transition-colors duration-300 disabled:opacity-60 shrink-0"
                  data-testid="audition-vote-btn"
                >
                  <Star size={13} /> {voted ? `Voted · ${applicant.votes}` : `Vote · ${applicant.votes}`}
                </button>
              </div>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
